export const state = () => {
  return {
    registry: {},
  }
}

export const getters = {
  getRegistry: (state) => state.registry,
}

export const mutations = {
  REGISTRY_COMPONENT(state, key: string) {
    state.registry[key] = key
  },
  REGISTRY_COMPONENTS(state, keys: string[]) {
    for (const key of keys) {
      state.registry[key] = key
    }
  },
}

export const actions = {
  registryComponent({ commit }, key: string): void {
    commit('REGISTRY_COMPONENT', key)
  },
}
